<template>
  <screen
    :screen-info="stepInfo"
    :step="stepIndex + 1"
    :can-skip="true"
    @leave="$emit('leave')"
    @skip="$emit('skip')"
  >
    <slider @mounted="initSlider">
      <!-- Wear skin tight -->
      <div class="splide__slide">
        <img
          src="../../../assets/MobileScan/skin-tight.png"
          :alt="$t('mobileScan.begin_info')"
        />
      </div>
      <!-- Make phone vertical -->
      <div class="splide__slide">
        <img
          src="../../../assets/MobileScan/vertical-phone.svg"
          :alt="$t('mobileScan.vertical_info')"
        />
      </div>
      <!-- Make sure whole body is in screen & take front view photo -->
      <div class="splide__slide">
        <img
          src="../../../assets/MobileScan/in-screen-front.png"
          :alt="$t('mobileScan.inscreen_front_info')"
        />
      </div>
      <!-- Make sure whole body is in screen & take side view photo -->
      <div class="splide__slide">
        <img
          src="../../../assets/MobileScan/in-screen-side.png"
          :alt="$t('mobileScan.inscreen_side_info')"
        />
      </div>
    </slider>
    <c-button v-if="stepIndex == totalSteps - 1" class="text-white" @click="$emit('next')">
      <span>{{ $t('login.continue') }}</span>
    </c-button>
    <div v-else class="py-3 h-45px"></div>
    <step-lines :step="currentStep" :steps="totalSteps" class="mt-4" />
  </screen>
</template>

<script>
import '@splidejs/splide/dist/css/splide-core.min.css';
import Splide from '@splidejs/splide';
import audioPlayer from '@/mixins/audio-player';
import Screen from '@/components/common/Screen.vue';
import Slider from '@/components/common/Slider.vue';
import StepLines from '@/components/common/StepLines.vue';
import CButton from '@/components/common/CButton.vue';

const SPLIDE_OPTIONS = {
  perPage: 1,
  arrows: false,
  width: 350,
  pagination: false,
};

export default {
  name: 'Slides',
  mixins: [audioPlayer],
  components: {
    Screen,
    Slider,
    StepLines,
    CButton,
  },
  data: () => ({
    stepIndex: 0,
  }),
  beforeDestroy() {
    this.destroySlider();
  },
  methods: {
    initSlider() {
      if (this.$splide) {
        this.$splide.destroy();
        this.$splide = null;
      }
      const $splide = document.querySelector('.splide');
      if ($splide) {
        this.$splide = new Splide($splide, SPLIDE_OPTIONS).mount();
        this.$splide.on('moved', this.onSlideMoved);
      } else {
        console.log('slide container is not there');
      }

      this.onSlideMoved(0);
      this.playAudio('ms-04-wear_tight', true);
    },
    onSlideMoved(index) {
      if (this.stepIndex === index) return;
      this.stepIndex = index;
      if (index === 0) {
        this.playAudio('ms-04-wear_tight', true);
      } else if (index === 1) {
        this.playAudio('ms-05-vertical', true);
      } else if (index === 2) {
        this.playAudio('ms-06-in_screen', true);
      } else if (index === 3) {
        this.playAudio('ms-06-side_screen', true);
      }
    },
    next() {
      this.stopAudio();
      this.$emit('next');
    },
    destroySlider() {
      if (this.$splide) {
        this.$splide.destroy();
      }
      this.$splide = null;
    },
  },
  computed: {
    stepInfo() {
      const info = [
        this.$t('mobileScan.begin_info'),
        this.$t('mobileScan.vertical_info'),
        this.$t('mobileScan2.inscreen_front_info'),
        this.$t('mobileScan2.inscreen_side_info'),
      ];
      return info[this.stepIndex];
    },
    currentStep() {
      return this.stepIndex + 1;
    },
    isLastStep() {
      return this.currentStep === this.totalSteps;
    },
    totalSteps() {
      return 4;
    },
    stepMargin() {
      return this.isLastStep ? 'mt-6' : 'mt-16';
    },
  },
  watch: {
  },
};
</script>

<style lang="scss" scoped>
.splide__slide {
  @apply flex justify-center items-center mb-6;
  min-height: 300px;
  width: 350px;
}

.splide__slide img {
  max-height: 50vh;
}

.h-45px {
  height: 45px;
}
</style>
